<template>
    <dashboard>
        <row>
            <panel size="col-24">
                <h2 slot="title">Beacon Report</h2>
                <template slot="buttons">
                    <app-button
                        size="small"
                        icon="icon-download"
                        class="no-text"
                        @click="handleDownload">
                        <span class="visuallyhidden">Download Report</span>
                    </app-button>
                </template>
                <el-table
                    :data="report"
                    :default-sort="{ prop: sort_by }"
                    style="width: 100%"
                    empty-text="None"
                    @sort-change="sortChange">
                    <el-table-column prop="factory_id" label="Factory ID" sortable="custom"/>
                    <el-table-column prop="location.name" label="Location Name" sortable="custom"/>
                    <el-table-column prop="battery" 
                                     label="Battery" 
                                     width="110" 
                                     sortable="custom"/>
                </el-table>

                <pagination
                    :current-page="page"
                    :page-size="per_page"
                    :total="total"
                    layout="prev, pager, next, total"
                    @current-change="pageChange"/>
            </panel>
        </row>
    </dashboard>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import table from '@/mixins/table'
import download from '@/mixins/download'

export default {
    name: 'page-reports-beacon',
    mixins: [download, table],
    props: {
        factory_id: String,
        per_page: {
            type: Number,
            default: 100
        }
    },
    data() {
        return {
            tableParamKeys: ['factory_id']
        }
    },
    computed: {
        ...mapState({
            report: ({ reportList }) => reportList.items,
            total: ({ reportList }) => reportList.total,
            authToken: ({ me }) => me.token
        })
    },
    mounted() {
        this.getBeaconReport(this.getParameters())
    },
    methods: {
        ...mapActions(['getBeaconReport']),
        handleDownload() {
            let parameters = this.getParameters()
            this.postParameters('/api/v2/download/report/beacon',
                parameters,
                this.authToken)
        },
        paramsChanged(params) {
            this.getBeaconReport(params)
        }
    }
}
</script>

<style lang="stylus"></style>
